// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"afbb3f41","374":"6059662d","422":"8a8ded71","499":"30dd9008","514":"78649ef7","818":"ab2bd1c8"}[chunkId] + ".chunk.js";
};